import { render, staticRenderFns } from "./searcher.vue?vue&type=template&id=2c74b651"
import script from "./searcher.vue?vue&type=script&lang=js"
export * from "./searcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports